import { render } from "./MaterialListing.vue?vue&type=template&id=2cacd364&scoped=true"
import script from "./MaterialListing.vue?vue&type=script&lang=js"
export * from "./MaterialListing.vue?vue&type=script&lang=js"

import "./MaterialListing.vue?vue&type=style&index=0&id=2cacd364&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cacd364"]])

export default __exports__